import { assignShipToAddressModalStyles } from "@insite/content-library/Widgets/UserSetup/AssignShipToAddressModal";
import { userSetupSettingsStyles } from "@insite/content-library/Widgets/UserSetup/UserSetupSettings";
import { userSetupStatusStyles } from "@insite/content-library/Widgets/UserSetup/UserSetupStatus";
import { userSetupUserInformationStyles } from "@insite/content-library/Widgets/UserSetup/UserSetupUserInformation";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { blackBlueBtn } from "@tKgpco/Extensions/Components/WishListCardExtension";
import { headerStyles } from "@tKgpco/Overrides/Widgets/AccountSettings/AccountSettingsHeader";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import merge from "lodash/merge";
import { css } from "styled-components";

Object.assign(userSetupSettingsStyles, {
    title: { variant: "h3", weight: 600 },
    wrapper: {
        css: css`
            padding-bottom: 15px;
            label {
                font-size: 14px;
            }
        `,
    },
});

Object.assign(userSetupStatusStyles, {
    title: { variant: "h3", weight: 600 },
    lastSignInLabel: {
        size: 14,
        weight: 600,
        css: css`
            margin-bottom: 5px;
        `,
    },
    accountStatusLabel: {
        variant: "h4",
        weight: 600,
        css: css`
            margin-bottom: 5px;
        `,
    },
    accountStatusText: {
        size: 13,
        css: css`
            display: block;
            margin-bottom: 10px;
        `,
    },
    lastSignInText: {
        size: 14,
    },
    sendActivationEmailButton: blackBlueBtn.actionDeleteButton,
});

Object.assign(userSetupUserInformationStyles, {
    title: { variant: "h3", weight: 600 },
    wrapper: {
        css: css`
            padding-bottom: 15px;
            label {
                font-size: 14px;
            }
        `,
    },
});

Object.assign(assignShipToAddressModalStyles, {
    saveButton: blackBlueBtn.actionAddToCartButton,
    cancelButton: headerStyles.cancelButton,
});
